/**
  * 商城 接口的统一出口
  */
 import axios from '../http' // 导入http中创建的axios实例
 import qs from 'qs' // 根据需求是否导入qs模块，把请求字段直接映射过来
 
//  const api = '/home/'
 
 const index = {
    // 外链列表
    linklist (params) {
		return axios.get('/home/xianli/linklist', {params,params})
	},
	// 支持单位
	supportunitlist (params) {
        return axios.get('/home/xianli/supportunitlist', {params,params})
	},
	// 献礼文章列表
	list (params) {
        return axios.get('/home/xianli/list', {params,params})
	},
	// 献礼文章详情
	detail (params) {
        return axios.get('/home/xianli/detail', {params,params})
	},
	// 助力献礼
	help (params){
		return axios.post('/home/xianli/help', qs.stringify(params))
	},
	// 助力列表
	helplist (params) {
        return axios.get('/home/xianli/helplist', {params,params})
	},
	// 发布评论
	postcomment(params){
		return axios.post('/home/xianli/postcomment', qs.stringify(params))
	},
	// 评论列表
	commentlist(params){
		return axios.get('/home/xianli/commentlist', {params,params})
	},
	// 发布献礼文章
	postarticle(params){
		return axios.post('/home/xianli/postarticle', qs.stringify(params))
	},
	// 省市区联动 查询
	areaList(params){
		return axios.get('/home/xianli/arealist', { params: params })
	},
	// 判断我是否发布献礼，及状态
	ispublish(params){
		return axios.get('/home/xianli/ispublish', { params: params })
	}
    
 }
 
 // 导出接口
 export default index